module.exports = __webpack_public_path__ + "img/20.d8458baf.png";